import { toast } from "react-toastify";
import { GetAllStockApi } from "../../../Api/Store/Stock";

export const GetAllStock = (data) => {
  return {
    type: "get_all_stock",
    payload: data,
    loader: false,
  };
};

export function getallStock(materialId) {
  return async (dispatch) => {
    try {
      const result = await GetAllStockApi(materialId);

      if (result.data?.IsSuccess === true) {
        dispatch(GetAllStock(result.data.Data));
      } else {
        toast.error(result.data?.Message || "Failed to fetch stock");
      }
    } catch (error) {
      toast.error("Something went wrong while fetching stock!");
    }
  };
}
